import type { Story } from '@/store/story-types'

export const STREETWEAR_DROP_STORY: Story = {
  id: 'streetwear-drop',
  name: 'DROPZONE - Streetwear Drops',
  narrative:
    'A limited-edition streetwear drop store with a bold dark aesthetic, urgency-driven product drops, and a streamlined purchase flow.',
  goals: [
    'Create urgency with limited-edition drop hero',
    'Showcase streetwear products in a bold grid layout',
    'Enable quick product viewing and cart additions',
    'Provide fast checkout for time-sensitive drops',
    'Confirm orders with clear confirmation page',
  ],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home',
      title: 'Home',
      order: 0,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'home',
      description:
        'Drop landing page with hero countdown, product grid, and brand story',
      blockRef: { category: 'store', blockId: 'drop-hero' },
    },
    {
      id: 'pg-product-detail',
      title: 'Product Detail',
      order: 1,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'product-detail',
      description: 'Product detail with images, sizing, stock count, and add-to-cart',
      blockRef: { category: 'store', blockId: 'product-detail' },
    },
    {
      id: 'pg-cart',
      title: 'Cart',
      order: 2,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'cart',
      description: 'Shopping cart with item list, quantities, and checkout button',
      blockRef: { category: 'store', blockId: 'cart-view' },
    },
    {
      id: 'pg-checkout',
      title: 'Checkout',
      order: 3,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'checkout',
      description: 'Checkout form with shipping, payment, and order summary',
      blockRef: { category: 'store', blockId: 'checkout' },
    },
    {
      id: 'pg-order-confirmation',
      title: 'Order Confirmed',
      order: 4,
      status: 'draft',
      elementCount: 1,
      linkedPageId: 'order-confirmation',
      description: 'Order confirmation with drop details and tracking info',
      blockRef: { category: 'store', blockId: 'order-confirmation' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-browse-drop',
      name: 'Browse Drop Collection',
      steps: [
        { type: 'given', text: 'the shopper is on the home page' },
        { type: 'when', text: 'the page loads' },
        {
          type: 'then',
          text: 'the drop hero with countdown and product grid are visible',
          linkedPageId: 'home',
        },
      ],
    },
    {
      id: 'bdd-view-product',
      name: 'View Product Detail',
      steps: [
        { type: 'given', text: 'the shopper is browsing the product grid' },
        { type: 'when', text: 'the shopper taps on a streetwear item' },
        {
          type: 'then',
          text: 'the product detail page shows images, price, available sizes, and stock count',
          linkedPageId: 'product-detail',
        },
      ],
    },
    {
      id: 'bdd-add-to-cart',
      name: 'Add Drop Item to Cart',
      steps: [
        { type: 'given', text: 'the shopper is viewing a product detail page' },
        { type: 'when', text: 'the shopper selects a size and taps "Add to Cart"' },
        {
          type: 'then',
          text: 'the item is added to the cart and the cart count updates',
          linkedPageId: 'cart',
        },
      ],
    },
    {
      id: 'bdd-checkout',
      name: 'Complete Drop Purchase',
      steps: [
        { type: 'given', text: 'the shopper has items in the cart' },
        { type: 'when', text: 'the shopper proceeds to checkout and completes payment' },
        {
          type: 'then',
          text: 'the order is confirmed with drop details and estimated delivery',
          linkedPageId: 'order-confirmation',
        },
      ],
    },
  ],
}
